import React, { useState, useEffect } from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import Tritech_2 from "../../../assets/images/Tritech_2.svg"
import antesDeUsar from '../../../assets/images/performance/antes de usar cup.webp'

import "./benefits-product-special.scss"

const BenefitsProductSpecial = ({ params, mobile, haveShopSecret, flujoType, code }) => {
  const isEC = process.env.LOCALE === "es-EC"
  const isCL = process.env.LOCALE === "es-CL"
  const isBO = process.env.LOCALE === "es-BO"
  const urlPantiesAbsorbentes = "https://www.nosotrasonline.com.ec/magazin/nuestro-mundo/panties-absorbentes-y-reutilizables-para-el-periodo-intimawear-de-nosotras-ecuador/"
  const isCup = code.includes("CUP")
  const urlVideo = () => {
    if(isCup){
      return 'https://www.youtube.com/embed/QSq1aL4aYzU'
    }else{
      switch (process.env.LOCALE) {
        case "es-CL":
          return "https://www.youtube.com/embed/mfMaADDce64"
        default:
          return "https://www.youtube.com/embed/PA-fMYeXMXQ"
      }
    }
  }

  const benefits = !isCup ? [
    {
      id: 1,
      description: (
        <p>
          Al usarlos <b>ayudas a cuidar el planeta</b> pues generan 90% menos
          residuos y tienen 82% menos impacto en el medio ambiente.
        </p>
      ),
    },
    {
      id: 2,
      description: (
        <p>
          Aunque tienen varias capas{" "}
          {isEC && (
            <a
              target="_blank"
              href={urlPantiesAbsorbentes}
            >
              absorbentes
            </a>
          )}
           {!isEC && "absorbentes"}, no se notan por debajo de tu ropa pues están hechos con{" "}
          <b>poliéster</b>, un material que ofrece mayor absorción que el
          algodón y que te permitirá seguir usando tu ropa preferida.
        </p>
      ),
    },
    {
      id: 3,
      description: process.env.LOCALE !== "es-CL" && (
        <p>
          Están disponibles en{" "}
          <a
            target="_blank"
            href={
              isEC
                ? "https://www.tiendanosotras.com.ec/"
                : "https://www.tiendanosotras.com/"
            }
          >
            Tiendanosotras.com
          </a>
          , un portal súper completo donde además podrás encontrar
          acompañamiento para escoger los intimawear perfectos para ti.
        </p>
      ),
    },
  ] : [
      {
        id: 1,
        description: (
          <>
          <b style={{'font-size':'18px'}}>1. Ponte cómoda</b>
          <p>
            Busca la posición más cómoda para introducirla dentro de tu vagina;
            puede ser de pie, sentada, en cuclillas o con una pierna sobre el sanitario.
            ¡Relájate antes de hacerlo!
          </p></>),
      },
      {
        id: 2,
        description: (
          <>
          <b style={{'font-size':'18px'}}>2. Inserta</b>
          <p>
            Una vez doblada, separa los labios de la vagina y ubica la copa en la entrada de esta.
            Respira hondo y relaja tus músculos para poder deslizar la copa suavemente en dirección a tu espalda.
            Empuja suavemente hasta que el tallo esté a la misma altura de la entrada de la vagina.
          </p></>),
      },
      {
        id: 3,
        description: (
          <>
          <b style={{'font-size':'18px'}}>3. Ajusta</b>
          <p>
            Una vez dentro, sostén la base inferior de la copa (no el tallo) y gírala en un
            círculo completo (hacia cualquier dirección) para crear un sello, de esta forma
            se previenen derrames y te mantendrás protegida.
          </p>
          </>
        ),
      },
  ]

  if (!haveShopSecret) benefits.pop()

  return (
    <section className={`f-benefits-section-product-special `}>
      <div className="f-background-container">
        <div className="f-section-container">
          {!isCup ? 
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title={
              mobile ? "¡Sus beneficios!" : "¡Sus beneficios son increíbles!"
            }
          />:
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title={ "Ponte tu Nosotras® V-cup"}
          />}
        </div>

        <div className="f-section-container">
          <div className="f-left-section">
            <p className="f-text-description-title ">
              {isCup ? null:
              isCL ? (
                <>
                  Conoce algunos de los beneficios de utilizar el Calzón
                  Reutilizable Íntimawear de Nosotras
                </>
              ) : (
                <>
                  Conoce algunos de los beneficios de usar{" "}
                  {isBO
                    ? "la ropa interior"
                    : "los Panty"}{" "}
                  intimawear de Nosotras
                </>
              ) }
            </p>
            <div className="f-description-container">
              <ul>
                {benefits.map(benefit => (
                  <li key={benefit.id}>{benefit.description}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="f-right-section">
            <div className="f-video-container">
              <iframe
                src={urlVideo()}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="f-section-container">
        {!isCup ? 
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title={` Además, ${
              isBO
                ? " intimawear está diseñados"
                : isCL
                ? "el Calzón Reutilizable está diseñado"
                : "están los panties diseñados"
            } con una revolucionaria tecnología inteligente:`}
          /> :
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title="Antes del primer uso"/>}
        </div>
        <div className="f-section-container">
          <div className="f-left-section">
          {isCup? null
              :
            <p className="f-text-description-title ">
              {isBO
                ? "La ropa interior intimawear de Nosotras cuenta con"
                : isCL
                ? "El Calzón Reutilizable Íntimawear de Nosotras cuenta con"
                : "El panty intimawear de Nosotras cuenta con"}{" "}
              tecnología Tritech, para que ahora, vivas la libertad de no sentir
              nada y estar protegida gracias a sus tres capas especiales:
            </p>}
            <div className="f-description-container">
              {isCup ?
                <ul>
                  <li>
                    Asegúrate de lavar la V-Cup antes de empezar a usarla en cada período. Adicionalmente
                    tus manos deben estar limpias, lávalas con agua y jabón antes de ponerte tu Nosotras V-Cup.
                  </li>
                  <li>
                    <b style={{ 'font-size': '18px' }}>Esteriliza</b>
                  </li>
                  <li>
                    <p>Una copa limpia es una copa saludable. Por lo tanto, es muy importante sumergirla en agua hirviendo 
                       de 5 a 7 minutos antes usarla por primera vez y antes de cada período. Lo podrás hacer en una olla.</p>
                    <br />
                    <p>Lava tu copa con agua y jabón neutro, te recomendamos estirar cada orificio y dejar que corra
                      agua tibia por ellos para eliminar cualquier residuo.</p>
                    <br />
                    <p>Algunos productos pueden dañar tu copa o causarte irritación por lo que no debes
                      usarlos para limpiarla, por ejemplo: gel o jabón antibacterial, alcohol, bicarbonato,
                      peróxido de hidrógeno/agua oxigenada, blanqueador, jabón para platos, vinagre o sustancias
                      a base de petróleo, como vaselina.
                    </p>
                  </li>
                  <li>
                    <b style={{ 'font-size': '18px' }}>Elige un doblez</b>
                  </li>
                  <li>
                    <p>Para introducir tu Nosotras V-Cup debes doblarla para que se ajuste perfectamente a ti y
                      debes mantenerla doblada hasta que esté dentro de tu vagina. Hay diferentes formas de doblarla,
                      elige la que mejor se adapte a ti.
                    </p>
                  </li>
                  <li>
                    <b>Doblez en C o en U</b>
                    <p>Presiona los bordes de la copa y doblalos para formar una C o U</p>
                  </li>
                  <li>
                    <b>Doblez en V</b>
                    <p>Pon tu dedo índice en el borde superior de la copa y empuja hacia adentro para formar
                      un triángulo en forma de V.
                    </p>
                  </li>
                </ul> : 
              <ul>
                <li>
                  La primera es suave, absorbe el flujo con rápidez y aleja la
                  humedad del cuerpo, para que te sientas seca todo el tiempo.
                </li>
                <li>
                  La segunda capa, además de ser absorbente, también retiene el
                  flujo <b>y controla los olores {flujoType.includes('Moderado') ? 'de 8 a 12' : 'por 12'} horas.</b>
                </li>
                <li>
                  Y la tercera es respirable, para mayor frescura y comodidad.
                </li>
              </ul>}
            </div>
          </div>
          <div className="f-right-section">
            {isCup ? <img src={antesDeUsar} alt="Antes de usar Cup" />:
            <img src={Tritech_2} alt="tritech performance" />}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BenefitsProductSpecial
